__turbopack_context__.v({
  "calculatorCard": "j7Oula_calculatorCard",
  "calculatorFooter": "j7Oula_calculatorFooter",
  "calculatorMainTitle": "j7Oula_calculatorMainTitle",
  "calculatorPanel": "j7Oula_calculatorPanel",
  "calculatorTabs": "j7Oula_calculatorTabs",
  "calculatorText": "j7Oula_calculatorText",
  "hasTabs": "j7Oula_hasTabs",
  "tabIcon": "j7Oula_tabIcon",
});
